export const SOURCE_STUDY_GRID_FIELD = 'sourceStudyId';
